var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"primary",attrs:{"autofocus":true}},_vm.$listeners),[_vm._v("\n\t"+_vm._s(_vm.t('core', 'Install recommended apps'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }